import { render, staticRenderFns } from "./Summit.vue?vue&type=template&id=42dfb6c8&scoped=true&"
import script from "./Summit.vue?vue&type=script&lang=js&"
export * from "./Summit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dfb6c8",
  null
  
)

export default component.exports